/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const createGroupBodyDescriptionMax = 150;

export const createGroupBodyIdMin = 2;

export const createGroupBodyInitialRolesItemDescriptionMax = 150;

export const createGroupBodyInitialRolesItemNameMin = 2;
export const createGroupBodyInitialRolesItemNameMax = 50;

export const createGroupBodyInitialRolesMax = 10;

export const createGroupBodyMemberPermissionsMax = 10;

export const createGroupBodyNameMin = 2;
export const createGroupBodyNameMax = 50;

export const CreateGroupBody = zod.object({
  description: zod.string().max(createGroupBodyDescriptionMax).optional(),
  id: zod.string().min(createGroupBodyIdMin),
  initialRoles: zod
    .array(
      zod.object({
        description: zod.string().max(createGroupBodyInitialRolesItemDescriptionMax).optional(),
        name: zod
          .string()
          .min(createGroupBodyInitialRolesItemNameMin)
          .max(createGroupBodyInitialRolesItemNameMax),
      }),
    )
    .max(createGroupBodyInitialRolesMax)
    .optional(),
  memberPermissions: zod.array(zod.string()).max(createGroupBodyMemberPermissionsMax).optional(),
  name: zod.string().min(createGroupBodyNameMin).max(createGroupBodyNameMax),
  parentGroupActorUuid: zod.uuid().optional(),
  visibility: zod.enum(['PUBLIC', 'PRIVATE', 'SECRET']).optional(),
});

export type CreateGroupBody = zod.input<typeof CreateGroupBody>;
export type CreateGroupBodyOutput = zod.output<typeof CreateGroupBody>;
